<li
  data-test-notification="{notification.type}"
  on:click="{click}"
  class="ne-notification ne-{notification.type}">
  <span class="ne-notification-icon">
    {#if notification.type === 'error' || notification.type === 'warning'}
      <AlertIcon />
    {/if}
    {#if notification.type === 'success'}
      <SuccessIcon />
    {/if}
  </span>
  <span class="ne-notification-message">{@html notification.message}</span>
  <span class="ne-notification-x">{notification.dismissable ? "+" : ""}</span>
</li>

<style>
  :global(.ne-notification) {
    margin: 0;
    margin-bottom: 0.5em;
    padding: 1em;
    cursor: pointer;
    display: flex;
    align-items: center;
    border-radius: .25em;
    min-width: 100%;
    font-size: .875em;
    line-height: 1.125em;
    max-width: 80%;
  }

  @media (min-width: 768px) {
    :global(.ne-notification) {
      min-width: 30vw;
      max-width: 480px;
    }
  }

  :global(.ne-notification) {
    box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.3);
  }

  :global(.ne-error) {
    background-color: #f3c8cc;
  }

  :global(.ne-warning) {
    background-color: #fff0b2;
  }

  :global(.ne-success) {
    background-color: #c3e6d5;
  }

  :global(.ne-error .ne-notification-icon) {
    fill: #ce2333;
  }

  :global(.ne-warning .ne-notification-icon) {
    fill: #ff9014;
  }

  :global(.ne-success .ne-notification-icon) {
    fill: #37ac74;
  }

  :global(.ne-notification-message) {
    flex: 1;
    padding: 0 1em;
  }

  :global(.ne-notification-x) {
    font-size: 2rem;
    transform: rotate(45deg);
  }
</style>

<script>
  import AlertIcon from './AlertIcon.html';
  import SuccessIcon from './SuccessIcon.html';

  export let remove;
  export let notification;

  function click() {
    notification.dismissable ? remove(notification.id) : null;
  }
</script>
